var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { INDRAURLService } from "@ibe.services/url.indra.service";
import { Router, ActivatedRoute } from "@angular/router";
import { INDRAStorageService } from "@ibe.services/storage.indra.service";
import { INDRAApiService } from "@ibe.services/api.indra.service";
import { LoginModalService } from "@ibe.services/login-modal.service";
import { HttpClient } from "@angular/common/http";
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as UserActions from '@ibe/store/actions/user.actions';
import { URL_DEEPLINK_LOGIN, MOCK_STATUS, MOCK_LOGIN, DEFAULT_MARKET, DEFAULT_LANGUAGE, TRIP_TYPE_MULTICITY, TRIP_TYPE_ONE_WAY, TRIP_TYPE_ROUND_TRIP, DEEPLINK_FLIGHT_TYPE_SINGLE, DEEPLINK_FLIGHT_TYPE_RETURN, DEEPLINK_DATES_PAGE, DEEPLINK_FLIGHTS_PAGE, URL_DEEPLINK_FLOW, MOCK_URL_DEEPLINK_FLOW, DEEPLINK_FLIGHT_TYPE_MULTICITY, DEEPLINK_FLIGHTS_PAGE_STOPOVER, URL_LOGIN, DEEPLINK_STOPOVER_ROUTE_EXCEPTION } from '@ibe.config';
import { INDRALanguageMarketService } from "./language-market-indra.service";
import { INDRADateService } from "./date.indra.service";
import * as i0 from "@angular/core";
import * as i1 from "./url.indra.service";
import * as i2 from "@angular/router";
import * as i3 from "./storage.indra.service";
import * as i4 from "./api.indra.service";
import * as i5 from "./login-modal.service";
import * as i6 from "@angular/common/http";
import * as i7 from "./language-market-indra.service";
import * as i8 from "@ngrx/store";
import * as i9 from "./date.indra.service";
var INDRADeepLinkService = /** @class */ (function () {
    function INDRADeepLinkService(urlService, router, storage, api, loginModalService, http, activatedRoute, languageMarketSService, store, dateService) {
        this.urlService = urlService;
        this.router = router;
        this.storage = storage;
        this.api = api;
        this.loginModalService = loginModalService;
        this.http = http;
        this.activatedRoute = activatedRoute;
        this.languageMarketSService = languageMarketSService;
        this.store = store;
        this.dateService = dateService;
        this.milesGoDiscount = true;
        this.headerFooterHidden = false;
    }
    INDRADeepLinkService.prototype.INDRA_getDeepLinkInformation = function (url) {
        var deeplinkInfo = {
            pnr: null,
            ticketnumber: null,
            lastname: null,
            source: null,
            market: null,
            language: null,
            uh: null,
            tapid: null,
            email: null
        };
        if ((url.indexOf('pnr') !== -1 ||
            url.indexOf('ticketnumber') !== -1) &&
            url.indexOf('lastname') != -1 &&
            url.indexOf('source') !== -1 &&
            url.indexOf('market') !== -1 &&
            url.indexOf('language') !== -1) {
            deeplinkInfo.pnr = this.urlService.INDRA_getUrlParams('pnr', url);
            deeplinkInfo.ticketnumber = this.urlService.INDRA_getUrlParams('ticketnumber', url);
            deeplinkInfo.lastname = this.urlService.INDRA_getUrlParams('lastname', url);
            deeplinkInfo.source = this.urlService.INDRA_getUrlParams('source', url);
            deeplinkInfo.market = this.urlService.INDRA_getUrlParams('market', url);
            if (deeplinkInfo.market.toUpperCase() === 'UK') {
                deeplinkInfo.market = 'GB';
            }
            deeplinkInfo.language = this.urlService.INDRA_getUrlParams('language', url);
            if (deeplinkInfo.language.includes('-')) {
                // parses the en-en, pt-PT, and es-ES to iso code..
                var parsedLanguage = deeplinkInfo.language;
                deeplinkInfo.language = parsedLanguage.substring(0, 2);
            }
            deeplinkInfo.uh = this.urlService.INDRA_getUrlParams('uh', url);
            deeplinkInfo.tapid = this.urlService.INDRA_getUrlParams('tapid', url);
            deeplinkInfo.email = this.urlService.INDRA_getUrlParams('email', url);
            sessionStorage.setItem('deeplinkRedirect', 'YES');
        }
        return deeplinkInfo;
    };
    INDRADeepLinkService.prototype.INDRA_processDeepLinkInfo = function (deeplinkInfo) {
        var _this = this;
        var pnr;
        var lastName;
        if (deeplinkInfo.ticketnumber) {
            pnr = deeplinkInfo.ticketnumber;
        }
        else {
            pnr = deeplinkInfo.pnr;
        }
        lastName = deeplinkInfo.lastname;
        this.languageMarketSService.setMarket(deeplinkInfo.market.toUpperCase());
        var sessionLanguage = sessionStorage.getItem("language");
        if (!sessionLanguage) {
            this.languageMarketSService.setLanguage(deeplinkInfo.language.toLowerCase());
        }
        this.storage.set('deepLink', deeplinkInfo);
        if (deeplinkInfo.email && deeplinkInfo.tapid) {
            this.INDRA_deeplinkLogin(deeplinkInfo.email, deeplinkInfo.tapid).subscribe(function (response) {
                if ((response.status === '200' || !response.errors || response.errors.length === 0) && response.data) {
                    _this.loginModalService.sendDataCustomer(response.data);
                    var _d = response.data, userProfile = _d.userProfile, userPnrs = _d.userPnrs, translate = _d.translate;
                    var userData = __assign({}, userProfile, { userPnrs: userPnrs, translate: translate });
                    _this.storage.set('userData', userData);
                }
                else {
                    sessionStorage.setItem('deeplinkLoginError', 'YES');
                }
                _this.router.navigate(['/my-bookings/details/' + pnr + '/' + lastName]);
            }, function (err) {
                console.log(err);
                sessionStorage.setItem('deeplinkLoginError', 'YES');
                _this.router.navigate(['/my-bookings/details/' + pnr + '/' + lastName]);
            });
        }
        else {
            this.router.navigate(['/my-bookings/details/' + pnr + '/' + lastName]);
        }
    };
    INDRADeepLinkService.prototype.INDRA_deeplinkLogin = function (email, tapid) {
        var payload = {
            email: email,
            tapId: tapid
        };
        if (MOCK_STATUS.DEEPLINK_LOGIN) {
            return this.http.get(MOCK_LOGIN);
        }
        else {
            return this.api.INDRA_post(URL_DEEPLINK_LOGIN, payload);
        }
    };
    INDRADeepLinkService.prototype.INDRA_getBookingFlowDeeplinkParameter = function (urlQueryParams, deeplinkType) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionLanguage, market, language, origin, destination, flightType, adt, chd, inf, yth, departureDate, returnDate, hash, networkName, promocode, voucher, voucherEmail, flexibleDates, headerFooterHidden, award, email, tapid, uid, anetwork, anetid, utm_source, utm_campaign, utm_content, utm_medium, _a, _b, _c, milesPromo, origin1, origin2, origin3, origin4, origin5, destination1, destination2, destination3, destination4, destination5, depDate1, depDate2, depDate3, depDate4, depDate5, otp, originArray, destinationArray, depDateArray, stopoverCode, country, days, country1, days1, stopoverCode1, stopoverRoute, stopoverRoute1, isStopover, baggageIncluded, cabinOptions, onlyRefundable, directFlights, tapAirline, skyscannerRedirectId, metapartner, forgerocktoken, x_tap_source, x_tap_username, x_tap_correlationid, tripType, apiParam, deeplinkAPiPromise, err_1, deeplinkParameter;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        sessionLanguage = sessionStorage.getItem("language");
                        market = urlQueryParams['market'] !== undefined ? urlQueryParams['market'] : sessionStorage.getItem("market");
                        language = sessionLanguage ? sessionLanguage : urlQueryParams['language'];
                        language = language ? language.toLowerCase() : '';
                        origin = urlQueryParams['origin'];
                        destination = urlQueryParams['destination'];
                        flightType = urlQueryParams['flightType'];
                        adt = urlQueryParams['adt'];
                        chd = urlQueryParams['chd'] ? urlQueryParams['chd'] : '0';
                        inf = urlQueryParams['inf'] ? urlQueryParams['inf'] : '0';
                        yth = urlQueryParams['yth'];
                        departureDate = urlQueryParams['depDate'];
                        returnDate = urlQueryParams['retDate'];
                        hash = urlQueryParams['uh'];
                        networkName = urlQueryParams['networkName'];
                        promocode = urlQueryParams['promocode'];
                        voucher = urlQueryParams['voucher'];
                        voucherEmail = urlQueryParams['voucherEmail'];
                        flexibleDates = urlQueryParams['flexibleDates'];
                        headerFooterHidden = urlQueryParams['headerfooterhidden'];
                        if (headerFooterHidden) {
                            this.headerFooterHidden = JSON.parse(headerFooterHidden);
                        }
                        award = urlQueryParams['award'];
                        email = urlQueryParams['email'];
                        tapid = urlQueryParams['tapid'];
                        uid = urlQueryParams['uid'];
                        anetwork = urlQueryParams['anetwork'];
                        anetid = urlQueryParams['anetid'];
                        utm_source = urlQueryParams['utm_source'];
                        utm_campaign = urlQueryParams['utm_campaign'];
                        utm_content = urlQueryParams['utm_content'];
                        utm_medium = urlQueryParams['utm_medium'];
                        _a = urlQueryParams['_a'];
                        _b = urlQueryParams['_b'];
                        _c = urlQueryParams['_c'];
                        milesPromo = urlQueryParams['milesPromo'];
                        origin1 = urlQueryParams['origin1'];
                        origin2 = urlQueryParams['origin2'];
                        origin3 = urlQueryParams['origin3'];
                        origin4 = urlQueryParams['origin4'];
                        origin5 = urlQueryParams['origin5'];
                        destination1 = urlQueryParams['destination1'];
                        destination2 = urlQueryParams['destination2'];
                        destination3 = urlQueryParams['destination3'];
                        destination4 = urlQueryParams['destination4'];
                        destination5 = urlQueryParams['destination5'];
                        depDate1 = urlQueryParams['depDate1'];
                        depDate2 = urlQueryParams['depDate2'];
                        depDate3 = urlQueryParams['depDate3'];
                        depDate4 = urlQueryParams['depDate4'];
                        depDate5 = urlQueryParams['depDate5'];
                        otp = urlQueryParams['otp'];
                        originArray = [];
                        destinationArray = [];
                        depDateArray = [];
                        stopoverCode = urlQueryParams['stopoverCode'];
                        country = urlQueryParams['country'];
                        days = urlQueryParams['days'];
                        country1 = urlQueryParams['country1'];
                        days1 = urlQueryParams['days1'];
                        stopoverCode1 = urlQueryParams['stopoverCode1'];
                        stopoverRoute = urlQueryParams['stopoverRoute'];
                        stopoverRoute1 = urlQueryParams['stopoverRoute1'];
                        isStopover = urlQueryParams['stopover'];
                        baggageIncluded = urlQueryParams['baggageIncluded'];
                        cabinOptions = urlQueryParams['cabinOptions'];
                        onlyRefundable = urlQueryParams['onlyRefundable'];
                        directFlights = urlQueryParams['directFlights'];
                        tapAirline = urlQueryParams['tapAirline'];
                        skyscannerRedirectId = urlQueryParams['skyscannerRedirectId'];
                        metapartner = urlQueryParams['metapartner'];
                        forgerocktoken = urlQueryParams['forgerocktoken'];
                        x_tap_source = urlQueryParams['x_tap_source'];
                        x_tap_username = urlQueryParams['x_tap_username'];
                        x_tap_correlationid = urlQueryParams['x_tap_correlationid'];
                        switch (flightType) {
                            case DEEPLINK_FLIGHT_TYPE_SINGLE:
                                tripType = TRIP_TYPE_ONE_WAY;
                                break;
                            case DEEPLINK_FLIGHT_TYPE_RETURN:
                                tripType = TRIP_TYPE_ROUND_TRIP;
                                break;
                            case DEEPLINK_FLIGHT_TYPE_MULTICITY:
                                tripType = TRIP_TYPE_MULTICITY;
                                break;
                            default:
                                tripType = TRIP_TYPE_ONE_WAY;
                                break;
                        }
                        if (departureDate) {
                            departureDate = this.parseDate(departureDate);
                        }
                        if (returnDate) {
                            returnDate = this.parseDate(returnDate);
                        }
                        if (deeplinkType === DEEPLINK_FLIGHT_TYPE_MULTICITY ||
                            (deeplinkType === DEEPLINK_FLIGHTS_PAGE_STOPOVER && tripType === TRIP_TYPE_MULTICITY)) {
                            if (depDate1) {
                                depDate1 = this.parseDate(depDate1);
                            }
                            if (depDate2) {
                                depDate2 = this.parseDate(depDate2);
                            }
                            if (depDate3) {
                                depDate3 = this.parseDate(depDate3);
                            }
                            if (depDate4) {
                                depDate4 = this.parseDate(depDate4);
                            }
                            if (depDate5) {
                                depDate5 = this.parseDate(depDate5);
                            }
                            depDateArray.push(departureDate, depDate1, depDate2, depDate3, depDate4, depDate5);
                            originArray.push(origin, origin1, origin2, origin3, origin4, origin5);
                            destinationArray.push(destination, destination1, destination2, destination3, destination4, destination5);
                            depDateArray = depDateArray.filter(function (date) { return date != undefined; });
                            originArray = originArray.filter(function (orig) { return orig != undefined; });
                            destinationArray = destinationArray.filter(function (dest) { return dest != undefined; });
                        }
                        // validations for required values
                        switch (deeplinkType) {
                            case DEEPLINK_DATES_PAGE:
                                if (!origin || origin.length === 0 || !destination || destination.length === 0)
                                    return [2 /*return*/, null];
                                break;
                            case DEEPLINK_FLIGHTS_PAGE:
                                if (!origin || origin.length === 0 || !destination || !departureDate || destination.length === 0 ||
                                    (tripType === TRIP_TYPE_ROUND_TRIP && (!returnDate || returnDate.length === 0)) ||
                                    (departureDate && !moment(departureDate, "DD.MM.YYYY", true).isValid()) ||
                                    (tripType === TRIP_TYPE_ROUND_TRIP && returnDate && !moment(returnDate, "DD.MM.YYYY", true).isValid())) {
                                    return [2 /*return*/, null];
                                }
                                break;
                            case DEEPLINK_FLIGHT_TYPE_MULTICITY:
                                if (!origin || origin.length === 0 || !destination || destination.length === 0 ||
                                    originArray.length != depDateArray.length || originArray.length != destinationArray.length || depDateArray.length != destinationArray.length ||
                                    !depDateArray[1] || !originArray[1] || !destinationArray[1] ||
                                    (departureDate && !moment(departureDate, "DD.MM.YYYY", true).isValid())
                                    || depDateArray.length < 1 || originArray.length < 1 || destinationArray.length < 1) {
                                    return [2 /*return*/, null];
                                }
                                break;
                            case DEEPLINK_FLIGHTS_PAGE_STOPOVER:
                                if (!origin || origin.length === 0 || !destination || !departureDate || destination.length === 0 ||
                                    (tripType === TRIP_TYPE_ROUND_TRIP && (!returnDate || returnDate.length === 0)) ||
                                    (departureDate && !moment(departureDate, "DD.MM.YYYY", true).isValid()) ||
                                    (tripType === TRIP_TYPE_ROUND_TRIP && returnDate && !moment(returnDate, "DD.MM.YYYY", true).isValid())
                                    || !stopoverCode || !country || !days) {
                                    return [2 /*return*/, null];
                                }
                                if (tripType === TRIP_TYPE_MULTICITY && !origin1 && !destination1 && !depDate1) {
                                    return [2 /*return*/, null];
                                }
                                break;
                            default:
                                break;
                        }
                        // check for correct hash
                        // if (hash) {
                        // 	if (flightType === DEEPLINK_FLIGHT_TYPE_SINGLE || flightType === DEEPLINK_FLIGHT_TYPE_RETURN) {
                        // 		const paramHashString = DEEPLINK_MAGIC_WORD + '_' + origin + destination + (departureDate ? departureDate : '') + (returnDate ? returnDate : '') + adt + chd + inf;
                        // 		const md5 = new Md5();
                        // 		const generatedHash = md5.appendStr(paramHashString).end();
                        // 		if (generatedHash !== hash) {
                        // 			return null;
                        // 		}
                        // 	}
                        // }
                        if (networkName !== 'EMUNDO') {
                            // miles&go promo
                            if (award == 'true' && milesPromo == 'Y') {
                                milesPromo = null;
                            }
                            if (milesPromo == 'Y' && inf != '0') {
                                milesPromo = null;
                            }
                            // vouchers & promocodes
                            if (milesPromo == 'Y' && (voucher || promocode)) {
                                voucher = null;
                                voucherEmail = null;
                                promocode = null;
                            }
                            if (award == 'true' && voucher) {
                                voucher = null;
                                voucherEmail = null;
                            }
                        }
                        // pre-processing of market and language
                        if (!sessionLanguage) {
                            if (language && language.includes('-')) {
                                if (language.toLowerCase() != 'pt-br') {
                                    language = language.substring(0, 2);
                                }
                            }
                            else {
                                language = language && language !== 'null' && language.length > 0 ? language : DEFAULT_LANGUAGE;
                            }
                        }
                        if (market && market.toUpperCase() === 'UK') {
                            market = 'GB';
                        }
                        else if (market && market.toUpperCase() === 'RU') {
                            market = 'PT';
                        }
                        else {
                            market = market && market !== 'null' && market.length > 0 ? market.toUpperCase() : DEFAULT_MARKET;
                        }
                        apiParam = {
                            network: networkName,
                            origin: origin,
                            origin1: origin1,
                            origin2: origin2,
                            origin3: origin3,
                            origin4: origin4,
                            origin5: origin5,
                            destination: destination,
                            destination1: destination1,
                            destination2: destination2,
                            destination3: destination3,
                            destination4: destination4,
                            destination5: destination5,
                            depDate: departureDate ? this.INDRA_formatDateParam(departureDate) : '',
                            depDate1: depDate1 ? this.INDRA_formatDateParam(depDate1) : '',
                            depDate2: depDate2 ? this.INDRA_formatDateParam(depDate2) : '',
                            depDate3: depDate3 ? this.INDRA_formatDateParam(depDate3) : '',
                            depDate4: depDate4 ? this.INDRA_formatDateParam(depDate4) : '',
                            depDate5: depDate5 ? this.INDRA_formatDateParam(depDate5) : '',
                            award: award,
                            email: email,
                            tapid: tapid,
                            anetwork: anetwork,
                            anetid: anetid,
                            utmSource: utm_source,
                            utmContent: utm_content,
                            utmMedium: utm_medium,
                            a: _a,
                            b: _b,
                            c: _c,
                            voucher: voucher,
                            voucherEmail: voucherEmail,
                            milesPromo: milesPromo,
                            retDate: returnDate ? this.INDRA_formatDateParam(returnDate) : '',
                            adt: urlQueryParams['adt'],
                            chd: urlQueryParams['chd'] ? urlQueryParams['chd'] : '0',
                            inf: urlQueryParams['inf'] ? urlQueryParams['inf'] : '0',
                            flightType: flightType,
                            market: market,
                            language: language,
                            promocode: promocode ? promocode : '',
                            hash: hash,
                            skyscannerRedirectId: skyscannerRedirectId,
                            otp: otp,
                            metapartner: metapartner,
                            forgerocktoken: forgerocktoken,
                            x_tap_source: x_tap_source,
                            x_tap_username: x_tap_username,
                            x_tap_correlationid: x_tap_correlationid,
                        };
                        if (!(apiParam.origin && apiParam.destination && apiParam.adt && apiParam.flightType)) return [3 /*break*/, 4];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.INDRA_deeplinkFlow(apiParam).toPromise()];
                    case 2:
                        deeplinkAPiPromise = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _d.sent();
                        console.error('deeplink api error: ' + JSON.stringify(err_1));
                        return [3 /*break*/, 4];
                    case 4:
                        this.languageMarketSService.setMarket(market);
                        if (language && !sessionLanguage) {
                            this.languageMarketSService.setLanguage(language);
                        }
                        deeplinkParameter = {
                            market: market,
                            language: (language && language.length > 0 ? language : DEFAULT_LANGUAGE),
                            origin: origin,
                            destination: destination,
                            flightType: tripType,
                            adultCount: adt ? parseInt(adt, 10) : 0,
                            childCount: chd ? parseInt(chd, 10) : 0,
                            infantCount: inf ? parseInt(inf, 10) : 0,
                            youngAdultCount: yth ? parseInt(yth, 10) : 0,
                            promocode: promocode,
                            hash: hash,
                            networkName: networkName,
                            departureDate: departureDate,
                            arrivalDate: returnDate,
                            award: award === 'true' ? true : false,
                            email: email,
                            tapid: tapid,
                            uid: uid,
                            anetid: anetid,
                            originArray: originArray,
                            destinationArray: destinationArray,
                            depDateArray: depDateArray,
                            milesPromo: milesPromo,
                            voucher: voucher,
                            voucherEmail: voucherEmail,
                            stopoverCode: stopoverCode,
                            isStopover: isStopover ? (isStopover === 'true' ? true : false) : undefined,
                            country: country,
                            days: days ? parseInt(days, 10) : 0,
                            days1: days1 ? parseInt(days1, 10) : 0,
                            country1: country1,
                            stopoverCode1: stopoverCode1,
                            stopoverRoute: stopoverRoute,
                            stopoverRoute1: stopoverRoute1,
                            flexibleDates: flexibleDates,
                            headerfooterhidden: headerFooterHidden,
                            baggageIncluded: baggageIncluded,
                            cabinOptions: cabinOptions,
                            onlyRefundable: onlyRefundable,
                            directFlights: directFlights,
                            tapAirline: tapAirline,
                            skyscannerRedirectId: skyscannerRedirectId,
                            otp: otp,
                            metapartner: metapartner,
                            forgerocktoken: forgerocktoken,
                            x_tap_source: x_tap_source,
                            x_tap_username: x_tap_username,
                            x_tap_correlationid: x_tap_correlationid,
                        };
                        return [2 /*return*/, deeplinkParameter];
                }
            });
        });
    };
    INDRADeepLinkService.prototype.INDRA_setMarketLanguageForTTTCompletionFlow = function (urlQueryParams) {
        var sessionLanguage = sessionStorage.getItem("language");
        var market = urlQueryParams['market'] !== undefined ? urlQueryParams['market'] : sessionStorage.getItem("market");
        // let language = urlQueryParams['language'] !== undefined ? urlQueryParams['language'].toLowerCase() : sessionStorage.getItem("language");
        var language = sessionLanguage ? sessionLanguage : urlQueryParams['language'];
        language = language ? language.toLowerCase() : '';
        // pre-processing of market and language
        if (!sessionLanguage) {
            if (language && language.length > 0) {
                if (language.includes('-')) {
                    language = language.substring(0, 2);
                }
            }
            else {
                // language = DEFAULT_LANGUAGE;
                language = null;
            }
        }
        if (market && market.length > 0) {
            if (market.toUpperCase() === 'UK') {
                market = 'GB';
            }
            market = market.toUpperCase();
        }
        else {
            // market = DEFAULT_MARKET;
            market = null;
        }
        if (market) {
            this.store.dispatch(new UserActions.PutMarketAction(market));
            this.languageMarketSService.setMarket(market);
        }
        if (language && !sessionLanguage) {
            this.languageMarketSService.setLanguage(language);
        }
        return { market: market, language: language };
    };
    INDRADeepLinkService.prototype.parseDate = function (dateStr) {
        var dateComponents = dateStr.match(/(\d+)/g);
        return new Date(dateComponents[2], dateComponents[1] - 1, dateComponents[0]);
    };
    INDRADeepLinkService.prototype.INDRA_deeplinkFlow = function (param) {
        if (MOCK_STATUS.DEEPLINK_FLOW) {
            return this.http.get(MOCK_URL_DEEPLINK_FLOW);
        }
        else {
            return this.api.INDRA_post(URL_DEEPLINK_FLOW, param);
        }
    };
    Object.defineProperty(INDRADeepLinkService.prototype, "milesGoPromo", {
        get: function () {
            return this.milesGoDiscount;
        },
        set: function (discount) {
            this.milesGoDiscount = discount;
        },
        enumerable: true,
        configurable: true
    });
    INDRADeepLinkService.prototype.INDRA_login = function (uid, forgerocktokenStr) {
        if (forgerocktokenStr === void 0) { forgerocktokenStr = null; }
        var data = {};
        if (!forgerocktokenStr) {
            var flyTapInfo = this.INDRA_getFlyTapInformation(uid);
            data = {
                flyTapLogin: true,
                flyTapToken: flyTapInfo.flyTapToken,
                customerId: flyTapInfo.customerId,
                forgerocktoken: forgerocktokenStr
            };
        }
        else {
            data = {
                forgerocktoken: forgerocktokenStr
            };
        }
        if (MOCK_STATUS.LOGIN) {
            return this.api.INDRA_get(MOCK_LOGIN);
        }
        else {
            return this.api.INDRA_post(URL_LOGIN, data);
        }
    };
    INDRADeepLinkService.prototype.INDRA_getFlyTapInformation = function (uidString) {
        var flyTapInfo = {
            flyTapLogin: true,
            customerId: null,
            flyTapToken: null
        };
        var uid = uidString;
        var uidParts = uid.split('.');
        var UIDLogin = JSON.parse(atob(uidParts[1]));
        flyTapInfo.customerId = UIDLogin.CustomerID;
        flyTapInfo.flyTapToken = uid;
        return flyTapInfo;
    };
    INDRADeepLinkService.prototype.INDRA_formatDateParam = function (date) {
        return this.dateService.INDRA_formatDate(date, 'DDMMYYYY');
    };
    INDRADeepLinkService.prototype.INDRA_setMarketLanguageForExternalDeeplink = function (urlQueryParams) {
        var sessionLanguage = sessionStorage.getItem("language");
        var market = urlQueryParams['market'] !== undefined ? urlQueryParams['market'] : sessionStorage.getItem("market");
        // let language = urlQueryParams['language'] !== undefined ? urlQueryParams['language'].toLowerCase() : sessionStorage.getItem("language");
        var language = sessionLanguage ? sessionLanguage : urlQueryParams['language'];
        language = language ? language.toLowerCase() : '';
        // pre-processing of market and language
        if (!sessionLanguage) {
            if (language && language.length > 0) {
                if (language.includes('-')) {
                    language = language.substring(0, 2);
                }
            }
            else {
                // language = DEFAULT_LANGUAGE;
                language = null;
            }
        }
        if (market && market.length > 0) {
            if (market.toUpperCase() === 'UK') {
                market = 'GB';
            }
            market = market.toUpperCase();
        }
        else {
            // market = DEFAULT_MARKET;
            market = null;
        }
        if (market) {
            this.store.dispatch(new UserActions.PutMarketAction(market));
            this.languageMarketSService.setMarket(market);
        }
        if (language && !sessionLanguage) {
            this.languageMarketSService.setLanguage(language);
        }
        return { market: market, language: language };
    };
    INDRADeepLinkService.prototype.INDRA_isRouteValidStopover = function (route) {
        return route && !DEEPLINK_STOPOVER_ROUTE_EXCEPTION.includes(route);
    };
    INDRADeepLinkService.ngInjectableDef = i0.defineInjectable({ factory: function INDRADeepLinkService_Factory() { return new INDRADeepLinkService(i0.inject(i1.INDRAURLService), i0.inject(i2.Router), i0.inject(i3.INDRAStorageService), i0.inject(i4.INDRAApiService), i0.inject(i5.LoginModalService), i0.inject(i6.HttpClient), i0.inject(i2.ActivatedRoute), i0.inject(i7.INDRALanguageMarketService), i0.inject(i8.Store), i0.inject(i9.INDRADateService)); }, token: INDRADeepLinkService, providedIn: "root" });
    return INDRADeepLinkService;
}());
export { INDRADeepLinkService };
